import { render, staticRenderFns } from "./query-main.vue?vue&type=template&id=dd7efb76&scoped=true"
import script from "./query-main.vue?vue&type=script&lang=js"
export * from "./query-main.vue?vue&type=script&lang=js"
import style0 from "./query-main.vue?vue&type=style&index=0&id=dd7efb76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd7efb76",
  null
  
)

export default component.exports